export const USER_ADMIN = 'user_admin';
export const USER_GYM_OWNER = 'user_gym_owner';
export const USER_COACH = 'user_coach';
export const USER_CLASS_PARTICIPANT = 'user_class_participant';

export const UserRolesEnum: string[] = [ USER_ADMIN, USER_GYM_OWNER, USER_COACH, USER_CLASS_PARTICIPANT];



// WEBPACK FOOTER //
// /usr/src/app/src/app/config/UserRoles.ts